import React from "react";
import { TurnrModalContent, TurnrModalHeader } from "~/components/modals/TurnrModal";
import OneClickOptionsWrapper, { OneClickTextOption } from "../../OneClickOptions";
import { getProductComplaintReasons } from "~/cores/productCore";
import { getReturnReasonTranslated } from "~/cores/appCore";

export default function ComplaintStepReason({ appProps, complaintStepperProps }) {
    const { getLocaleText, language } = appProps;

    const { onBack, onModalClose, product, onComplaintReasonSelected } = complaintStepperProps;

    const complaintReasons = getProductComplaintReasons(product);

    return (
        <>
            <TurnrModalHeader onBack={onBack} onClose={onModalClose} title={getLocaleText("complaint-type-title")} />
            <TurnrModalContent>
                <OneClickOptionsWrapper>
                    {complaintReasons?.map((complaintReason) => {
                        const complaintReasonId = complaintReason?.id;
                        const complaintLabel = getReturnReasonTranslated({
                            returnReason: complaintReason,
                            language,
                        });
                        return (
                            <OneClickTextOption key={complaintReasonId} dataTestId={`complaint-reason-${complaintReasonId}`} onClick={() => onComplaintReasonSelected(complaintReasonId)}>
                                {complaintLabel}
                            </OneClickTextOption>
                        );
                    })}
                    {getLocaleText("complaint-reasons-post-message")}
                </OneClickOptionsWrapper>
            </TurnrModalContent>
        </>
    );
}
